/* ============================================
   Purposeful Design — Shopify Theme
   theme.js
   ============================================ */

/* ---- Toast notification ---- */
function showToast(msg, duration) {
  duration = duration || 3000;
  let toast = document.getElementById('pd-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'pd-toast';
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => toast.classList.remove('show'), duration);
}

/* ---- Cart count badge ---- */
function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'inline' : 'none';
  });
}

/* ---- Add to cart (AJAX) ---- */
function addToCart(variantId, quantity, btn) {
  quantity = quantity || 1;
  if (btn) {
    btn.disabled = true;
    btn.textContent = 'Adding…';
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(r => r.json())
  .then(item => {
    if (item.status === 422) {
      showToast('Sorry — this item is sold out.');
    } else {
      showToast(item.title + ' added to cart ✓');
    }
    return fetch('/cart.js');
  })
  .then(r => r.json())
  .then(cart => updateCartCount(cart.item_count))
  .catch(() => showToast('Something went wrong. Please try again.'))
  .finally(() => {
    if (btn) {
      btn.disabled = false;
      btn.textContent = 'Add to Cart';
    }
  });
}

/* ---- Product quantity stepper ---- */
function initQtySteppers() {
  document.querySelectorAll('.qty-input').forEach(wrapper => {
    const minus = wrapper.querySelector('.qty-minus');
    const plus  = wrapper.querySelector('.qty-plus');
    const input = wrapper.querySelector('.qty-number');
    if (!minus || !plus || !input) return;
    minus.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
    plus.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });
}

/* ---- Product variant selector ---- */
function initVariantSelector() {
  const form = document.getElementById('product-form');
  if (!form) return;

  const swatches = form.querySelectorAll('.variant-swatch');
  const hiddenInput = form.querySelector('[name="id"]');
  const atcBtn = form.querySelector('.atc-btn');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      if (swatch.classList.contains('sold-out')) return;
      swatches.forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');
      if (hiddenInput) hiddenInput.value = swatch.dataset.variantId;
      // Update price display
      const price = swatch.dataset.price;
      const comparePrice = swatch.dataset.comparePrice;
      const priceEl = document.querySelector('.product-price');
      const compareEl = document.querySelector('.product-compare-price');
      if (priceEl && price) priceEl.textContent = price;
      if (compareEl && comparePrice) {
        compareEl.textContent = comparePrice;
        compareEl.style.display = comparePrice ? 'inline' : 'none';
      }
    });
  });

  form.addEventListener('submit', e => {
    e.preventDefault();
    if (!hiddenInput || !hiddenInput.value) return;
    const qty = form.querySelector('.qty-number');
    addToCart(hiddenInput.value, qty ? parseInt(qty.value, 10) : 1, atcBtn);
  });
}

/* ---- Product gallery thumbnails ---- */
function initGallery() {
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.product-gallery-main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImg.src = thumb.dataset.full || thumb.querySelector('img').src;
    });
  });
}

/* ---- Mobile menu ---- */
function initMobileMenu() {
  const hamburger = document.querySelector('.nav-hamburger');
  const menu = document.getElementById('mobile-menu');
  const close = document.getElementById('mobile-menu-close');

  if (!hamburger || !menu) return;

  hamburger.addEventListener('click', () => {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  function closeMenu() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (close) close.addEventListener('click', closeMenu);

  menu.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeMenu();
  });
}

/* ---- Cart item remove ---- */
function initCartRemovals() {
  document.querySelectorAll('[data-remove-item]').forEach(btn => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.removeItem;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(() => location.reload())
      .catch(() => showToast('Could not remove item.'));
    });
  });
}

/* ---- Cart qty update ---- */
function initCartQtyUpdate() {
  document.querySelectorAll('[data-cart-qty]').forEach(input => {
    let timer;
    input.addEventListener('change', () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const key = input.dataset.cartQty;
        const qty = parseInt(input.value, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(() => location.reload())
        .catch(() => showToast('Could not update cart.'));
      }, 500);
    });
  });
}

/* ---- Buy now ---- */
function initBuyNow() {
  const buyBtn = document.querySelector('.buy-now-btn');
  const form = document.getElementById('product-form');
  if (!buyBtn || !form) return;

  buyBtn.addEventListener('click', () => {
    const hiddenInput = form.querySelector('[name="id"]');
    const qty = form.querySelector('.qty-number');
    if (!hiddenInput || !hiddenInput.value) return;
    const variantId = hiddenInput.value;
    const quantity = qty ? parseInt(qty.value, 10) : 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(() => { window.location.href = '/checkout'; })
    .catch(() => showToast('Something went wrong.'));
  });
}

/* ---- Hero parallax (subtle) ---- */
function initHeroParallax() {
  const heroImg = document.querySelector('.hero-left img');
  if (!heroImg || window.innerWidth < 900) return;
  window.addEventListener('scroll', () => {
    const y = window.scrollY * 0.15;
    heroImg.style.transform = 'translateY(' + y + 'px)';
  }, { passive: true });
}

/* ---- Init all ---- */
document.addEventListener('DOMContentLoaded', () => {
  initMobileMenu();
  initVariantSelector();
  initQtySteppers();
  initGallery();
  initCartRemovals();
  initCartQtyUpdate();
  initBuyNow();
  initHeroParallax();
});
